import * as React from 'react'

import { ButtonsWrapper, Divider, FloatingContainer } from './styles'

// TODO Try to refactor away from `React.Children.map` and Divider.
//      Replace Divider with pseudoelement (::after or ::before)
//      and either :first-child or :last-child to exclude one.
//      Simpler and cleaner markup structure, template and DOM.
export const FloatingButtonGroup: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <FloatingContainer>
      <ButtonsWrapper>
        {React.Children.map(children, (child, index) => (
          <>
            {!!index && <Divider data-testid='floating-button-group-divider' />}
            {child}
          </>
        ))}
      </ButtonsWrapper>
    </FloatingContainer>
  )
}
